import { genericSupplierApiURL } from 'Constants/Constants';
import axios from 'axios';

const genericSupplierClient = axios.create({
  baseURL: genericSupplierApiURL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export default genericSupplierClient;
